import { FactType, TrendLabel } from '@/api/rest/resources/conservation';
import { useFact } from '@/pages/shared/projects/pages/project/pages/conservation/shared/hooks/useFact';
import { isNullish } from '@/utils/booleans';

export const useGetTrendLabel = ({ trendChangeFact }: { trendChangeFact: FactType }): TrendLabel | null => {
  // TODO: MVP-5183 the lablel calculation logic should be coded in the back end
  const trendChangePct = useFact<number>(trendChangeFact)?.value;

  if (isNullish(trendChangePct)) {
    return null;
  }

  if (trendChangePct >= 0.5) {
    return TrendLabel.increasing;
  }

  if (trendChangePct <= -0.5) {
    return TrendLabel.decreasing;
  }

  return TrendLabel.stable;
};
